<template>
  <div
    id="kt_modal_opcoes_pagamento_modal"
    ref="kt_modal_opcoes_pagamento_modal"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header p-3">
          <h4 class="modal-title">
            <img
              src="media/icons/duotune/finance/fin003.svg"
              class="me-2"
            />Forma de Pagamento
          </h4>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-8">
          <div class="row" v-if="this.errosGerais && this.errosGerais.Message">
            <div
              class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
            >
              <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                <inline-svg src="media/icons/duotune/general/gen044.svg" />
              </span>
              <div class="d-flex flex-stack flex-grow-1">
                <div class="fw-bold">
                  <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                  <div class="fs-6 text-gray-600">
                    {{ this.errosGerais.Message }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-4">
            <div data-kt-buttons="true">
              <label
                @click="this.formaSelecionada = 'Boleto'"
                class="btn btn-outline btn-outline-dashed btn-active-light-primary d-flex flex-stack text-start p-6 mb-5"
                v-bind:class="[
                  this.formaSelecionada === 'Boleto' ? 'active' : '',
                ]"
              >
                <div class="d-flex align-items-center me-2">
                  <div
                    class="form-check form-check-custom form-check-solid form-check-primary me-6"
                  >
                    <input
                      class="form-check-input"
                      type="radio"
                      value="Boleto"
                      :checked="this.formaSelecionada === 'Boleto'"
                      v-model="this.formaSelecionada"
                    />
                  </div>
                  <span class="svg-icon svg-icon-muted svg-icon-3hx me-4"
                    ><svg
                      width="44"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        opacity="0.3"
                        d="M3 6C2.4 6 2 5.6 2 5V3C2 2.4 2.4 2 3 2H5C5.6 2 6 2.4 6 3C6 3.6 5.6 4 5 4H4V5C4 5.6 3.6 6 3 6ZM22 5V3C22 2.4 21.6 2 21 2H19C18.4 2 18 2.4 18 3C18 3.6 18.4 4 19 4H20V5C20 5.6 20.4 6 21 6C21.6 6 22 5.6 22 5ZM6 21C6 20.4 5.6 20 5 20H4V19C4 18.4 3.6 18 3 18C2.4 18 2 18.4 2 19V21C2 21.6 2.4 22 3 22H5C5.6 22 6 21.6 6 21ZM22 21V19C22 18.4 21.6 18 21 18C20.4 18 20 18.4 20 19V20H19C18.4 20 18 20.4 18 21C18 21.6 18.4 22 19 22H21C21.6 22 22 21.6 22 21Z"
                        fill="currentColor"
                      />
                      <path
                        d="M3 16C2.4 16 2 15.6 2 15V9C2 8.4 2.4 8 3 8C3.6 8 4 8.4 4 9V15C4 15.6 3.6 16 3 16ZM13 15V9C13 8.4 12.6 8 12 8C11.4 8 11 8.4 11 9V15C11 15.6 11.4 16 12 16C12.6 16 13 15.6 13 15ZM17 15V9C17 8.4 16.6 8 16 8C15.4 8 15 8.4 15 9V15C15 15.6 15.4 16 16 16C16.6 16 17 15.6 17 15ZM9 15V9C9 8.4 8.6 8 8 8H7C6.4 8 6 8.4 6 9V15C6 15.6 6.4 16 7 16H8C8.6 16 9 15.6 9 15ZM22 15V9C22 8.4 21.6 8 21 8H20C19.4 8 19 8.4 19 9V15C19 15.6 19.4 16 20 16H21C21.6 16 22 15.6 22 15Z"
                        fill="currentColor"
                      />
                    </svg>
                  </span>
                  <div class="flex-grow-1">
                    <h2
                      class="d-flex align-items-center fs-3 fw-bold flex-wrap"
                    >
                      Boleto Bancário
                    </h2>
                    <div class="fw-semibold">
                      O processamento do boleto bancário poderá levar de 3 à 5
                      dias úteis.
                    </div>
                  </div>
                </div>
              </label>
              <label
                @click="this.formaSelecionada = 'PIX'"
                class="btn btn-outline btn-outline-dashed btn-active-light-primary d-flex flex-stack text-start p-6 mb-5"
                :class="[this.formaSelecionada === 'PIX' ? 'active' : '']"
              >
                <div class="d-flex align-items-center me-2">
                  <div
                    class="form-check form-check-custom form-check-solid form-check-primary me-6"
                  >
                    <input
                      class="form-check-input"
                      type="radio"
                      value="PIX"
                      :checked="this.formaSelecionada === 'PIX'"
                      v-model="this.formaSelecionada"
                    />
                  </div>
                  <span class="svg-icon svg-icon-muted svg-icon-3hx me-4"
                    ><svg
                      viewBox="0 0 512 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <defs />
                      <g fill="currentColor" fill-rule="evenodd">
                        <path
                          d="M393.072 391.897c-20.082 0-38.969-7.81-53.176-22.02l-77.069-77.067c-5.375-5.375-14.773-5.395-20.17 0l-76.784 76.786c-14.209 14.207-33.095 22.019-53.179 22.019h-9.247l97.521 97.52c30.375 30.375 79.614 30.375 109.988 0l97.239-97.238h-15.123zm-105.049 74.327c-8.55 8.53-19.93 13.25-32.05 13.25h-.02c-12.12 0-23.522-4.721-32.05-13.25l-56.855-56.855c7.875-4.613 15.165-10.248 21.758-16.84l63.948-63.948 64.23 64.23c7.637 7.66 16.188 14.013 25.478 18.952l-54.439 54.46zM310.958 22.78c-30.374-30.374-79.613-30.374-109.988 0l-97.52 97.52h9.247c20.082 0 38.97 7.834 53.178 22.02l76.784 76.785c5.57 5.592 14.622 5.57 20.17 0l77.069-77.068c14.207-14.187 33.094-22.02 53.176-22.02h15.123l-97.239-97.237zm6.028 96.346l-64.23 64.23-63.97-63.97c-6.593-6.592-13.86-12.206-21.736-16.818l56.853-56.877c17.69-17.645 46.476-17.668 64.121 0l54.44 54.461c-9.292 4.961-17.842 11.315-25.479 18.974h.001z"
                        />
                        <path
                          d="M489.149 200.97l-58.379-58.377h-37.706c-13.838 0-27.394 5.635-37.185 15.426l-77.068 77.069c-7.202 7.18-16.623 10.77-26.067 10.77-9.443 0-18.885-3.59-26.066-10.77l-76.785-76.785c-9.792-9.814-23.346-15.427-37.207-15.427h-31.81L22.78 200.97c-30.374 30.375-30.374 79.614 0 109.988l58.095 58.074 31.81.021c13.86 0 27.416-5.635 37.208-15.426l76.784-76.764c13.925-13.947 38.208-13.924 52.133-.02l77.068 77.066c9.791 9.792 23.346 15.405 37.185 15.405h37.706l58.379-58.356c30.374-30.374 30.374-79.613 0-109.988zm-362.19 129.724c-3.763 3.786-8.942 5.917-14.273 5.917H94.302l-48.59-48.564c-17.689-17.69-17.689-46.476 0-64.143L94.3 175.296h18.385c5.331 0 10.51 2.154 14.295 5.918l74.74 74.74-74.761 74.74zm339.257-42.647l-48.848 48.87h-24.305c-5.309 0-10.508-2.155-14.251-5.92l-75.023-75.043 75.023-75.023c3.743-3.764 8.942-5.918 14.252-5.918h24.304l48.847 48.891c8.573 8.551 13.273 19.93 13.273 32.05 0 12.141-4.7 23.52-13.273 32.093z"
                        />
                      </g>
                    </svg>
                  </span>
                  <div class="flex-grow-1">
                    <h2
                      class="d-flex align-items-center fs-3 fw-bold flex-wrap"
                    >
                      PIX
                    </h2>
                    <div class="fw-semibold">
                      Aprovação instantânea do pagamento.
                    </div>
                  </div>
                </div>
              </label>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            :id="`btnConfirmar`"
            @click="confirmar()"
            v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loading">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <LoadingModal
    :nomeRef="'loadingModalOpcoesPagamento'"
    :mensagem="this.mensagemLoading"
    v-if="this.loadingOpcoesPagamento === true"
  ></LoadingModal>
</template>

<script>
import { useToast } from "vue-toastification";
import {
  hideModal,
  getOrCreateInstanceModal,
  hideModalId,
} from "@/core/helpers/dom";
const toast = useToast();
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { mapState } from "vuex";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";

export default {
  emits: ["exibirOpcoesPagamentoModal", "confirmarOpcoesPagamentoModal"],
  components: { LoadingModal },
  computed: {
    ...mapState("auth", ["user"]),
  },
  props: {
    id: { type: Number, required: true },
  },
  methods: {
    async confirmar() {
      this.loading = true;
      try {
        if (this.licencaFatura && this.licencaFatura !== null) {
          await this.$swal.showQuestionAlert(
            "Confirma a forma de pagamento?",
            async (alert) => {
              if (alert.isConfirmed) {
                if (this.formaSelecionada === "Boleto") {
                  if (
                    this.licencaFatura.guid_boleto &&
                    this.licencaFatura.guid_boleto !== null
                  ) {
                    await this.$swal.showInvalidAlert(
                      "Já existe um boleto gerado para esta fatura, realize o pagamento do mesmo ou entre em contato com o financeiro."
                    );
                  } else {
                    await this.$swal.showInvalidAlert(
                      "O boleto bancário será gerado em seguida, clique em OK e aguarde.",
                      async (alert) => {
                        if (alert.isConfirmed) {
                          this.mensagemLoading = "Aguarde, gerando boleto...";
                          await this.exibirModalLoading(true);

                          let retGeracaoBoleto = await this.$store.dispatch(
                            "licencaRecebivel/postGerarBoleto",
                            this.id
                          );

                          if (retGeracaoBoleto.Success === true) {
                            await this.$swal.showSuccessAlert(
                              retGeracaoBoleto.Message,
                              async (alert) => {
                                await this.exibirModalLoading(false);
                                this.loading = false;

                                hideModal(
                                  this.$refs.kt_modal_opcoes_pagamento_modal
                                );
                                this.$emit("confirmarOpcoesPagamentoModal");
                              }
                            );
                          } else {
                            await this.$swal.showErrorAlert(
                              retGeracaoBoleto.Message
                            );
                          }
                          await this.exibirModalLoading(false);
                        }
                      }
                    );
                  }
                } else if (this.formaSelecionada === "PIX") {
                  await this.$swal.showInvalidAlert(
                    "O QR-Code do pix será gerado em seguida, realize o pagamento e aguarde a confirmação.",
                    async (alert) => {
                      this.mensagemLoading = "Aguarde, gerando a cobrança...";
                      await this.exibirModalLoading(true);

                      let retGeracaoCobranca = await this.$store.dispatch(
                        "licencaRecebivel/postGerarCobrancaImediata",
                        this.id
                      );

                      if (retGeracaoCobranca.Success === true) {
                        await this.$swal.showSuccessAlert(
                          retGeracaoCobranca.Message,
                          async (alert) => {
                            await this.exibirModalLoading(false);
                            this.loading = false;

                            hideModal(
                              this.$refs.kt_modal_opcoes_pagamento_modal
                            );
                            this.$emit("confirmarOpcoesPagamentoModal");
                          }
                        );
                      } else {
                        await this.$swal.showErrorAlert(
                          retGeracaoCobranca.Message
                        );
                      }

                      await this.exibirModalLoading(false);
                    }
                  );
                }
              }
            }
          );
        } else {
          await this.$swal.showInvalidAlert("A fatura não foi localizada!");
        }
      } catch (error) {
        if (error.Message) {
          await this.$swal.showErrorAlert(error.Message);
        } else {
          await this.$swal.showErrorAlert(error);
        }
      }
      await this.exibirModalLoading(false);
      this.loading = false;
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_opcoes_pagamento_modal);
      this.$emit("exibirOpcoesPagamentoModal", false);
    },
    async exibirModalLoading(exibir, callback) {
      if (exibir === true) {
        this.loadingOpcoesPagamento = true;
        getOrCreateInstanceModal(
          "loadingModalOpcoesPagamento",
          /*open*/ null,
          /*close*/ null
        );
      } else {
        hideModalId("loadingModalOpcoesPagamento", () => {
          this.loadingOpcoesPagamento = false;
          this.$nextTick(() => {
            if (callback) {
              callback();
            }
          });
        });
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
  async mounted() {
    this.loading = true;
    this.errosValidacao = [];
    this.errosGerais = [];
    try {
      let ret = await this.$store.dispatch(
        "licencaRecebivel/getLicencaRecebivel",
        this.id
      );

      if (ret.Success === true) {
        this.licencaFatura = ret.Data;
      }
    } catch (error) {
      console.log(error);
    }

    this.loading = false;
  },
  data() {
    return {
      errosGerais: [],
      errosValidacao: [],
      loading: false,
      licencaFatura: {},
      loadingOpcoesPagamento: false,
      formaSelecionada: "Boleto",
      mensagemLoading: "Aguarde...",
    };
  },
};
</script>

<style></style>
